import classes from './mention-badge.module.css';

/**
 * ### getMentionBadgeClasses
 *
 * @description
 * Returns the CSS classes for mention badge elements.
 * Used when creating mention badges dynamically in the DOM.
 *
 * @returns Object containing CSS class names
 */
export const getMentionBadgeClasses = (): {
  badge: string;
  invalid: string;
  closeButton: string;
} => ({
  badge: classes.badge || '',
  invalid: classes.invalid || '',
  closeButton: classes.closeButton || '',
});
